// src/utils/incidentColumnDefs.ts
import { ColDef, ValueGetterParams } from "ag-grid-community";
import { AdminRequestData } from "./adminRequestTypes";
import config from "../../config";
import "ag-grid-enterprise";
import { formatDuration } from "../durationUtils";

import FavoriteCheckbox from "../../Components/FavoriteCheckbox/FavoriteCheckbox";
const extractImageSrcOrText = (html: string): string => {
  const div = document.createElement("div");
  div.innerHTML = html;

  const img = div.querySelector("img");
  if (img && img.src) {
    return img.src; // Return the image URL
  }

  // Else return plain text
  return div.textContent || div.innerText || "";
};
const formatDateUTC3 = (date: Date | string | null): string => {
  if (!date) return "";

  const d = typeof date === "string" ? new Date(date.replace(" ", "T")) : date;

  return d.toLocaleString("en-GB", {
    timeZone: "Etc/GMT-2", // ✅ corrected
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};
const isAdmin = localStorage.getItem("isAdmin") === "true";
const isSuperAdmin = localStorage.getItem("superadmin") === "true";

function stripHtml(html: string): string {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}
const getColumnDefs = (
  handleEdit: (data: AdminRequestData) => void,
  handleDelete: (ticketId: string) => void
): ColDef<AdminRequestData>[] => {
  //console.log("isAdminnnnnnnnn", isAdmin);

  const columns: (ColDef<AdminRequestData> | false)[] = [
    {
      field: "ticketCreationDatetime",
      headerName: "Ticket Creation Date/Time",
      filter: "agDateColumnFilter",
      valueGetter: (params: any) => {
        const raw = params.data?.ticketCreationDatetime;
        return raw ? new Date(raw.replace(" ", "T")) : null;
      },
      filterValueGetter: (params: any) => {
        const raw = params.data?.ticketCreationDatetime;
        return raw ? new Date(raw.replace(" ", "T")) : null;
      },
      valueFormatter: (params: any) => formatDateUTC3(params.value),

      filterParams: {
        browserDatePicker: true,
        comparator: (filterLocalDateAtMidnight: Date, cellValue: Date) => {
          if (!cellValue) return -1;

          // Strip time from both values
          const cellDate = new Date(
            cellValue.getFullYear(),
            cellValue.getMonth(),
            cellValue.getDate()
          );

          if (cellDate < filterLocalDateAtMidnight) return -1;
          if (cellDate > filterLocalDateAtMidnight) return 1;
          return 0; // dates are equal
        },
      },
      sort: "desc",
      sortIndex: 3,
    },
    {
      field: "ticketClosureDatetime",
      headerName: "Ticket Closure Date/Time",
      filter: "agDateColumnFilter",
      valueGetter: (params: any) => {
        const raw = params.data?.ticketClosureDatetime;
        return raw ? new Date(raw.replace(" ", "T")) : null;
      },
      filterValueGetter: (params: any) => {
        const raw = params.data?.ticketClosureDatetime;
        return raw ? new Date(raw.replace(" ", "T")) : null;
      },
      valueFormatter: (params: any) => formatDateUTC3(params.value),

      filterParams: {
        browserDatePicker: true,
        comparator: (filterLocalDateAtMidnight: Date, cellValue: Date) => {
          if (!cellValue) return -1;

          // Strip time from both values
          const cellDate = new Date(
            cellValue.getFullYear(),
            cellValue.getMonth(),
            cellValue.getDate()
          );

          if (cellDate < filterLocalDateAtMidnight) return -1;
          if (cellDate > filterLocalDateAtMidnight) return 1;
          return 0; // dates are equal
        },
      },
    },
    {
      field: "closureCode",
      headerName: "Resolution Time",
    },

    {
      field: "ticketId",
      headerName: "Ticket ID",
      filter: "agTextColumnFilter",
      pinned: "left",
    },
    { field: "status", headerName: "Status" },

    {
      field: "description",
      headerName: "Description",
      valueGetter: (params: ValueGetterParams<AdminRequestData>) =>
        stripHtml(params.data?.description || ""),
      filter: "agTextColumnFilter",
    },
    {
      field: "resolutionTime",
      headerName: "Resolution Time",
    },
    {
      field: "type",
      headerName: "Type",
    },

        {
      field: "subType",
      headerName: "Sub Type",
    },
    {
      field: "resonPurpose",
      headerName: "Reson Purpose",
    },

    {
      field: "priority",
      headerName: "Priority",
    },

    {
      field: "status",
      headerName: "Status",
    },
    {
      field: "createdBy",
      headerName: "Created By",
    },
    {
      field: "closedBy",
      headerName: "Closed By",
    },
  ];

  return columns.filter(Boolean) as ColDef<AdminRequestData>[];
};

export default getColumnDefs;
